import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { obterArquivoCadernoPorId, obterArquivoCadernoPorIdFailure, obterArquivoCadernoPorIdSuccess } from '../../actions/Caderno/obter-arquivo-caderno-por-id.action';
import { CadernoService } from 'src/app/services/caderno.service';

@Injectable()
export class ObterArquivoCadernoPorIdEffects {

  public obterArquivoCadernoPorId$: unknown;

  constructor(private actions$: Actions,
    private cadernoService: CadernoService) {
    this.createEffects()
  }

  private createEffects() {
    this.obterArquivoCadernoPorId$ = createEffect(() => this.actions$.pipe(
      ofType(obterArquivoCadernoPorId),
      switchMap(({ inputDto }) =>
        this.cadernoService
          .ObterArquivoCadernoPorId(inputDto)
          .pipe(
            map(
              response => {
                if (response.erros != undefined && response.erros.length > 0) {
                  return obterArquivoCadernoPorIdFailure({ response })
                }
                return obterArquivoCadernoPorIdSuccess({ response })
              }),
            catchError(() => {
              return of()
            }
            )
          )
      )
    )
    );
  }
}
